import Modal from './Modal';
import { useEffect, useState } from 'react';

interface Props {
  title?: string;
  subtitle?: string;
}

function LoadingModal(props: Props) {
  const { title, subtitle } = props;

  const [allowClose, setAllowClose] = useState(false);

  useEffect(() => {
    setTimeout(() => setAllowClose(true), 30_000)
  }, []);

  return (
    <Modal preventClose={!allowClose}>
      <div className="flex flex-col items-center justify-center text-center bg-white p-8 pb-0 w-[600px] min-h-[400px]">
        <div className="text-2xl font-gilroy font-bold">{title ?? "Loading..."} </div>
        <div className="text-gray-600 mt-1">{subtitle}</div>
        <img src="https://static.portant.co/portant-loading-blue.svg" className="m-16 w-24 h-24" alt="Loading Logo" />
      </div>
    </Modal>
  );
}

export default LoadingModal;
